import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { PurchaseHistoryList } from '~components'
import { useTabView, UseTabViewProps } from '~hooks'
import { usePurchaseHistory, useRedeemedCoupons } from '~query-hooks'

export const useHistoryTabView = () => {
  const { t } = useTranslation()
  const {
    purchaseHistory,
    refetchPurchaseHistory,
    isFetchingPurchaseHistory,
  } = usePurchaseHistory()
  const {
    redeemedCoupons,
    refetchRedeemedCoupons,
    isFetchingRedeemedCoupons,
  } = useRedeemedCoupons()

  const FirstTab = useCallback(() => {
    return (
      <PurchaseHistoryList
        data={purchaseHistory}
        isLoading={isFetchingPurchaseHistory}
        onRefresh={refetchPurchaseHistory}
        refreshing={isFetchingPurchaseHistory}
      />
    )
  }, [purchaseHistory, refetchPurchaseHistory, isFetchingPurchaseHistory])

  const SecondTab = useCallback(() => {
    return (
      <PurchaseHistoryList
        data={redeemedCoupons}
        isLoading={isFetchingRedeemedCoupons}
        onRefresh={refetchRedeemedCoupons}
        refreshing={isFetchingRedeemedCoupons}
        emptyMessageKey="common.no_redeemed_coupons"
      />
    )
  }, [redeemedCoupons, refetchRedeemedCoupons, isFetchingRedeemedCoupons])

  const tabsData: UseTabViewProps['tabsData'] = useMemo(
    () => [
      { screen: FirstTab, key: 'offers_for_me', title: t('wallet_screen.purchase_history') },
      { screen: SecondTab, key: 'hot_deals', title: t('wallet_screen.redeemed') },
    ],
    [FirstTab, SecondTab, t]
  )
  const { tabBarView } = useTabView({ tabsData })

  return {
    offersListWithTabBarView: tabBarView,
    isLoadingHistory: isFetchingPurchaseHistory || isFetchingRedeemedCoupons,
  }
}
